import React from "react";
import AnalyticsDashboard from "../components/AnalyticsDashboard";

const ReviewPage: React.FC = () => {
  return <AnalyticsDashboard  />;
};

export default ReviewPage;
